import { FC } from "react";
import CustomPieChart from "../customPieChart";
import { CaseVolumeProps } from "../caseVolume/types";

const Top10Payors: FC<CaseVolumeProps> = ({ StatisticsObjectType }): JSX.Element => {

  return (
    <div className="row gx-3">
      <div className="col-12 col-lg-4">
        <CustomPieChart title={'Top 10 Payors'} pieChartObject={StatisticsObjectType.top_payors} />
      </div>
      <div className="col-12 col-lg-4">
        <CustomPieChart title={'Treatment Status Breakdown'} pieChartObject={StatisticsObjectType.ecr}/>
      </div>
      <div className="col-12 col-lg-4">
        <CustomPieChart title={'Cases By Submission Mode'} pieChartObject={StatisticsObjectType.mos}/>
      </div>
    </div>
  );
};

export default Top10Payors;
